import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
const colors = require('common/lib/colors/colors.less');
import fontFamily from '../data/font-family';

const ReplyContainerDiv = styled.div`
  background-color: ${colors.N20};
  border-radius: 0 0 4px 4px;
  border-top: 1px solid ${colors.N40};
  font-family: ${fontFamily};
  font-size: 14px;
  line-height: 1.33;
  overflow: hidden;
  position: relative;

  :empty {
    border: 0;
  }
`;

const SlideIn = styled.div`
  transition: 400ms transform, 400ms opacity, 400ms min-height;

  &.slide-enter,
  &.slide-appear {
    opacity: 0;
    transform: translateY(-32px);
  }

  &.slide-enter-active,
  &.slide-appear-active {
    opacity: 1;
    transform: translateY(0);
  }

  &.slide-exit {
    left: 0;
    opacity: 1;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateY(0);
  }

  &.slide-exit-active {
    left: 0;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateY(32px);
  }
`;

class AnimateHeight extends React.Component {
  constructor() {
    super();
    this.state = { height: 'auto', isAnimating: false };
  }

  // WTF PRETTIER KEEPS ADDING SEMICOLONS THAT TSLINT FAILS THE BUILDS FOR
  // tslint:disable:semicolon
  setInitialHeight = (height) => {
    this.setState({ height, isAnimating: true });
  };

  setTargetHeight = (height) => {
    const onAfterReflow = window.requestAnimationFrame || window.setTimeout;

    onAfterReflow(() => {
      this.setState({ height });
    });
  };

  endAnimation = () => {
    this.setState({ isAnimating: false });
  };
  // tslint:enable:semicolon

  render() {
    const { isAnimating, height } = this.state;

    const style = {
      height: isAnimating ? height : 'auto',
      transition: '200ms height',
    };

    return (
      <div style={style}>
        {this.props.render(
          this.setInitialHeight,
          this.setTargetHeight,
          this.endAnimation,
        )}
      </div>
    );
  }
}

export const ReplyContainer = ({ children, ...props }) => (
  <ReplyContainerDiv {...props}>
    <AnimateHeight
      render={(setInitialHeight, setTargetHeight, endAnimation) => (
        <TransitionGroup>
          {React.Children.map(children, (child) => (
            <CSSTransition
              key={child.key}
              timeout={400}
              classNames="slide"
              unmountOnExit={true}
              onExit={(node) => setInitialHeight(node.offsetHeight)}
              onEnter={(node) => setTargetHeight(node.offsetHeight)}
              onExited={() => endAnimation()}
            >
              <SlideIn>{child}</SlideIn>
            </CSSTransition>
          ))}
        </TransitionGroup>
      )}
    />
  </ReplyContainerDiv>
);



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/ReplyContainer.js